<template>
  <div class="gate">
    <div class="gate-icon">{{ ended ? "🎉" : "⏳" }}</div>
    <h1 class="gate-title">{{ ended ? "本活動已結束" : "活動尚未開始" }}</h1>
    <p class="gate-sub">
      {{ ended ? "感謝參與,敬請期待下次活動。" : "活動即將開跑,請稍候再回來。" }}
    </p>
    <p v-if="!ended && startText" class="gate-time">預計開始:{{ startText }}</p>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ status: string; startAt?: string | null }>();
const ended = computed(() => props.status === "ended" || props.status === "archived");
const startText = computed(() => {
  if (!props.startAt) return "";
  const d = new Date(props.startAt);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
});
</script>
<style scoped>
.gate {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  text-align: center;
  background: var(--bg-black);
  color: var(--text-primary);
}
.gate-icon { font-size: 56px; margin-bottom: 16px; }
.gate-title { font-size: 22px; font-weight: 700; margin: 0 0 10px; }
.gate-sub { font-size: 14px; color: var(--text-secondary); line-height: 1.7; margin: 0; }
.gate-time { font-size: 13px; color: var(--text-secondary); margin: 14px 0 0; opacity: .85; }
</style>
